import { h } from "preact";

import {
  classNames,
  countryCodeToFlagUrl,
  renderHtml,
  replaceRedactions,
} from "../helpers";
import { getPositionFromUser } from "../talentHelpers";
import Tooltip from "./Tooltip.jsx";
import i18n from "../i18n";

export default function UserPositionAndCountry({ smaller, user, ...props }) {
  const position = getPositionFromUser(user);
  if (!position && !user.country) {
    return null;
  }
  // TODO

  return (
    <p
      class={classNames(
        "talent-short-view__pos-country mt-0",
        smaller && "talent-short-view--smaller",
        props.class
      )}
      data-testid="pos-country"
    >
      {position && (
        <span class="talent-short-view__position">
          {renderHtml(replaceRedactions(position), "span")}
        </span>
      )}
      {position && user.country && ", "}
      {user.country && (
        <span class="talent-short-view__country">
          {user.country}{" "}
          {user.countryCode && (
            <span
              class="passpartout passpartout-24 ml-8"
              data-tooltip-id={`country-flag-${user.id}`}
            >
              <img src={countryCodeToFlagUrl(user.countryCode)} />
            </span>
          )}
          {user.countryCode && (
            <Tooltip
              className="nioomi-tooltip"
              id={`country-flag-${user.id}`}
              place="bottom"
            >
              {i18n.t("component.talent_short_view.country_flag_tooltip")}
            </Tooltip>
          )}
        </span>
      )}
    </p>
  );
}
